<template>
  <table class="entsys--table mobile--kipa-hide-header">
    <thead>
      <tr class="hidden-md-and-down">
        <th
          v-for="header in headersProp"
          :key="header.text"
          class="text-left"
          style
        >
          {{ header.text }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-show="loading || items.length == 0" class="pa-0">
        <td colspan="99" class="pa-0">
          <v-progress-linear
            :active="loading"
            color="secondary"
            indeterminate
          />

          <div
            v-if="loading && items.length == 0"
            class="text-center py-4 muted--text"
          >
            {{ $t("common:loading.messsage", "Loading...", "Loading message") }}
          </div>
          <div
            v-else-if="!loading && items.length == 0"
            class="text-center py-4 muted--text"
          >
            {{
              $t(
                "common:NoResults.messsage",
                "No data available",
                "No results message"
              )
            }}
          </div>
        </td>
      </tr>
      <template v-for="(item, i) in items">
        <tr :key="item.id + '-row'">
          <td>
            <router-link
              :to="{
                name: 'OrganisationProfilePage',
                params: { organisationId: item.id }
              }"
              class="d-block no-default-link-style"
            >
              {{ item.name }}
              <span v-if="item.shortName">| {{ item.shortName }}</span>
              &nbsp;<AppShowOrganisationDebtBadge :organisation="item" />
              <div class="hidden-lg-and-up mt-1">
                <small>
                  {{ item.identifier }}
                  <AppShowOrganisationLicenceBadge
                    v-if="item.membershipStatus === 'inactive'"
                    :organisation="item"
                  />
                  <AppValidationAlert
                    :check-valid="
                      item.membershipStatus === 'active' ? true : false
                    "
                    no-valid
                    :invalid="
                      $t(
                        'organisations:organisationProfile.membershipStatus.Inactive.label',
                        'Inactive',
                        'Label for inactive membership status'
                      )
                    "
                    class="ml-1"
                  />
                </small>
              </div>
            </router-link>
          </td>
          <td class="hidden-md-and-down">
            <div class="d-flex">
              <AppShowTopOrganisationLogo
                v-if="
                  item.topRegionOrganisation &&
                    item.topRegionOrganisation.logoPath
                "
                :organisation="item.topRegionOrganisation"
                class="mr-2"
                image-style="max-height: 20px;max-width: 54px"
              />

              {{ item.region ? item.region.name : "" }}
            </div>
          </td>

          <td class="hidden-md-and-down">
            <template v-if="item.address">
              {{ item.address.addressIndex }}
              {{ item.address.addressCity }}</template
            >
          </td>

          <td class="hidden-md-and-down">
            {{ item.identifier }}
            <AppShowOrganisationLicenceBadge :organisation="item" />
            <AppValidationAlert
              :check-valid="item.membershipStatus === 'active' ? true : false"
              no-valid
              :invalid="
                $t(
                  'organisations:organisationProfile.membershipStatus.Inactive.label',
                  'Inactive',
                  'Label for inactive membership status'
                )
              "
            />
          </td>

          <td class="hidden-md-and-down">
            {{ $t(`organisations:${item.membershipType}.label`) }}
          </td>
          <td class="hidden-lg-and-up text-center">
            <button
              class="btn-focus"
              :aria-label="$t('common:expandButton.alt')"
              @click.prevent="expand($event, item.id)"
            >
              <v-icon color="primary">
                $iconCircleCaretDown
              </v-icon>
            </button>
          </td>
        </tr>

        <tr
          v-if="expanded.includes(item.id)"
          :key="item.id + '-expanded'"
          class="hidden-lg-and-up"
        >
          <td colspan="99" class="pa-0">
            <v-card color="strong">
              <v-card-text>
                <div class="my-1">
                  <b>{{
                    $t(
                      "organisations:organisationProfile.label.region",
                      "Region",
                      "Label for field region"
                    )
                  }}</b>
                  <AppShowTopOrganisationLogo
                    v-if="
                      item.topRegionOrganisation &&
                        item.topRegionOrganisation.logoPath
                    "
                    :organisation="item.topRegionOrganisation"
                    class="ml-1"
                    image-style="max-height: 20px;max-width: 54px"
                  />
                  {{ item.region ? item.region.name : "" }}
                  <br />
                  <template v-if="item.address">
                    <b>{{
                      $t("organisations:fields.location.label", "Location")
                    }}</b>
                    {{ item.address.addressIndex }}
                    {{ item.address.addressCity }}
                  </template>
                </div>
                <div class="my-1">
                  <b>{{
                    $t(
                      "organisations:organisationProfile.label.memebershipType",
                      "Membership type",
                      "Label for field membership type"
                    )
                  }}</b>
                  {{ $t(`organisations:${item.membershipType}.label`) }}
                </div>
              </v-card-text>
            </v-card>
          </td>
        </tr>

        <tr
          v-if="showBannerConditionally(i, 'organisations')"
          :key="'-ad-' + item.id"
          class="no-hover hidden-lg-and-up pa-0"
          style="border: 0;"
        >
          <td colspan="99" class="pa-0">
            <AppShowBanners
              placement-name="ORGANISATIONS"
              :size="$vuetify.breakpoint.mdAndDown ? '150px' : undefined"
              :force-row="$vuetify.breakpoint.mdAndDown"
              class="py-4"
            />
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>
<script>
import { defineComponent } from "vue";
import { useBannerHelpers } from "@composables/banner_helpers";
import gql from "fraql";
import AppShowBanners from "@elements/banners/AppShowBanners.vue";
import AppValidationAlert from "@elements/AppValidationAlert.vue";
import AppShowTopOrganisationLogo from "@AppShows/organisation/AppShowTopOrganisationLogo.vue";
import AppShowOrganisationDebtBadge from "@AppShows/organisation/AppShowOrganisationDebtBadge.vue";
import AppShowOrganisationLicenceBadge from "@AppShows/organisation/AppShowOrganisationLicenceBadge.vue";

export default defineComponent({
  name: "SearchTemplateOrganisation",
  components: {
    AppShowTopOrganisationLogo,
    AppValidationAlert,
    AppShowBanners,
    AppShowOrganisationDebtBadge,
    AppShowOrganisationLicenceBadge
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const { showBannerConditionally } = useBannerHelpers();
    return { showBannerConditionally };
  },
  data() {
    return {
      expanded: []
    };
  },
  computed: {
    rootUrl() {
      return process.env.VUE_APP_API_URL;
    },
    headersProp() {
      return [
        {
          value: "name",
          text: this.$t(
            "organisations:fields.name.label",
            "Name",
            "Name field label"
          )
        },
        {
          value: "region",
          text: this.$t(
            "organisations:fields.region.label",
            "Region",
            "Region field label"
          ),
          hideMobile: true
        },
        {
          value: "location",
          text: this.$t("organisations:fields.location.label", "Location"),
          hideMobile: true
        },
        {
          value: "membershipStatus",
          text: this.$t(
            "organisations:fields.membership.label",
            "Membership",
            "Membership field label"
          ),
          hideMobile: true
        },
        {
          value: "membershipType",
          text: this.$t(
            "organisations:fields.membershiptype.label",
            "Membership type",
            "Membership type field label"
          ),
          hideMobile: true
        }
      ];
    }
  },
  methods: {
    expand(evt, id) {
      if (this.expanded.includes(id)) {
        this.expanded = this.expanded.filter(i => i != id);
      } else {
        this.expanded.push(id);
      }
      evt.target.classList.toggle("counter-rotate");
    }
  },
  fragments: {
    organisations: gql`
      fragment _ on Organisation {
        id
        name
        shortName
        regionId
        region @client {
          id
          name
        }
        ${AppShowOrganisationDebtBadge.fragments.organisationFields}
        ${AppShowOrganisationLicenceBadge.fragments.organisationFields}
        topRegionOrganisation {
          id
          name
          logoPath
          ${AppShowTopOrganisationLogo.fragments.organisationFields}
        }

        membershipStatus
        membershipType

        identifier
        address {
          id
          addressCity
          addressIndex
        }
      }
    `
  }
});
</script>
